export default __webpack_public_path__ + "static/media/activity-log-image.2be8f1ee.png";